import { Injectable } from '@angular/core';
import { Yii } from "libraries/interfaces/Yii";
import { IWenji } from "libraries/interfaces/IWenji";

@Injectable(
    {
        providedIn: 'root'
    }
)
export class LanguageService {

    /**
     * Gets current user full language code. Example : fr-FR
     */
    public get userLanguage(): string {
        return this.getUserLanguage();
    }

    /**
     * Gets current user simple language code. Example : fr
     */
    public get simpleUserLanguage(): string {
        const fullUserLanguage: string = this.getUserLanguage();
        return fullUserLanguage.includes('-') ? fullUserLanguage.split('-', 2)[0] : fullUserLanguage;
    }

    /**
     * Gets user language defined in Admin or use the default language from
     * Navigator.
     */
    public getUserLanguage (): string {
        return getUserLanguage();
    }
}

/**
 * Only for app module init. Please, use LanguageService elsewhere.
 */
export function getUserLanguage(): string {
    const w: { wenji: IWenji } = window as unknown as {wenji: IWenji};
    const yiiLanguage: string = Yii && Yii.translate && Yii.translate.config
        ? Yii.translate.config.language
        : null;

    if (yiiLanguage && isSupportedLanguage(yiiLanguage)) {
        return yiiLanguage;
    }

    if (w.wenji && w.wenji.ui && w.wenji.ui.language && isSupportedLanguage(w.wenji.ui.language)) {
        return w.wenji.ui.language;
    }

    if (sessionStorage && sessionStorage.getItem("language") && isSupportedLanguage(sessionStorage.getItem("language"))) {
        getStandardLanguage(sessionStorage.getItem("language"));
    }

    if (navigator.language && isSupportedLanguage(navigator.language)) {
        return navigator.language;
    }

    if ((navigator as any).userLanguage && isSupportedLanguage((navigator as any).userLanguage)) {
        return (navigator as any).userLanguage;
    }

    return 'fr';
}

const supportedLanguages: string[] = JSON.parse(sessionStorage.getItem("$supportedLanguageArray")) || ['fr','it','en','es','pt'];


function isSupportedLanguage($language: string): boolean {
    return supportedLanguages.includes($language);
}

function getStandardLanguage(language: string): string {
    if (language === 'pt') {
        return 'pt-PT';
    }
    return language;
}
